import { Tag } from 'src/app/_services/tag.service';

type InvDataDetails = 
    FileInfo | 
    PathInfo | 
    MediaInfo | 
    BackupSessionInfo | 
    TypeDirectoryInfo

export class InvData {
    constructor(details: InvDataDetails, parent?: InvData) {
        this.contentsFetched = false;
        this.parent = parent || null;
        this.details = details || null;
        this.contents = null;
    }

    /** a page of contents is on its way */
    loading: boolean;
    /** the last page failed to load */
    error: boolean;
    contentsFetched: boolean;
    parent: InvData | null;
    details: InvDataDetails;
    /** the pages loaded so far, for a folder or a backup session's top level */
    contents: InvData[];
    /** folders plus files, from the first page */
    total: number | null;
    folderCount: number | null;
    /** null once the last page is loaded */
    nextCursor: string | null;
    /** the sort the pages were loaded with */
    sort: ContentsSort | null;

    setContents(contents: InvData[]) {
        this.contentsFetched = true;
        this.contents = contents.map(d => {
            d.parent = this;
            return d;
        })
    }
}

/** how the API sorts a folder's contents; folders always come first */
export interface ContentsSort {
    sortBy: 'name' | 'size' | 'modifyDate';
    sortOrder: 'asc' | 'desc';
}

export interface TypeDirectoryInfo {
    id: string;
    name: string;
    mediaType?: MediaInfo['mediaType'] | 'SOURCES';
    type: 'PARENT';
}

export interface FileInfo {
    id: string;

    customerId: string;
    projectId: string;

    parentDirectoryId: string;
    
    media: string;

    backupSessionId: string;

    isEmailFile: string;
    hasFileContent: string;
    S3Link: string;

    Block: string;
    BlockOffset: string;
    FileMark: string;

    name: string;
    fileName: string;
    filePath: string;
    extension: string;

    modifyDate: number;
    accessDate: number;
    createDate: number;
    
    hash: string;
    size: number;
    tagged: boolean;
    /** named tags; absent or empty when none (a file can be tagged with no named tags) */
    tags?: Tag[];

    fileInformation: string;

    type: 'FILE';
};

export interface PathInfo {
    id: string;
    name: string;
    size: number;
    path: string;
    isRoot: boolean;
    hasFolderChild: boolean;
    hasFileChild: boolean;
    parentDirectoryId: string;
    backupSessionId: string;
    type: 'DIRECTORY';
}

export interface MediaInfo {
    id: string; // same as mediaId
    label: string;
    name: string; // same as label
    information: any;
    type: 'MEDIA';
    mediaType: 'TAPE' | 'SCAN';
}

export interface BackupSessionInfo {
    id: string;
    mediaId: string; // media that this backupsession belongs to

    name: string, // same as label
    label: string;
    backupDate: number;
    restorationConfig: any;
    size: number;
    type: 'BACKUP';
}